import { apiRequest } from '@/api'

export const authApi = {
  login(username, password) {
    return apiRequest('/api/login', {
      method: 'POST',
      body: { username, password }
    })
  },

  register(username, password, company) {
    return apiRequest('/api/register', {
      method: 'POST',
      body: { username, password, company }
    })
  },

  getCurrentUser() {
    return apiRequest('/api/currentUser')
  }
}

// ✅ 新增：移动端热更新
export const mobileApi = {
  /**
   * 获取 App 最新版本信息
   * 后端返回：{ success: true, data: { version, url, checksum, notes, created_at } }
   */
  getUpdateInfo() {
    return apiRequest('/api/mobile-update', { silent: true })
  }
}